module.exports = __webpack_public_path__ + "img/folder_card.c79ec4f4.svg";